import Wrapper from "../components/Wrappers/Wrapper";
import CountryDetailContainer from "../features/CountryDetail/CountryDetailContainer";

const CountryDetail: React.FC = () => {
  return (
    <Wrapper>
      <CountryDetailContainer />
    </Wrapper>
  );
};

export default CountryDetail;
